module.exports = __webpack_public_path__ + "img/bz21.6a967c82.svg";